export const adaptDatosGeneralesRI = ({ datosGeneralesRIByID }) => {
    const { datosGeneralesRINavigation } = datosGeneralesRIByID;
    return {
        idDatosGeneralesRI: datosGeneralesRINavigation?.idDatosGeneralesRI,
        datosGenerales1: {
            selectedPrograms: datosGeneralesRINavigation?.tipoModuloRI?.map(x => x.idTipoModulo),
            centroReferencia: datosGeneralesRINavigation?.centroReferencia,
            codInstitucionReferencia: datosGeneralesRINavigation?.codInstitucionReferencia,
            idComboRIValorLugarServicio: datosGeneralesRINavigation?.idComboRIValorLugarServicio,
            idComboRIValorLugarRI: datosGeneralesRINavigation?.idComboRIValorLugarRI,
            servicioEmergencia: datosGeneralesRINavigation?.servicioEmergencia,
            telefonoEmergencia: datosGeneralesRINavigation?.telefonoEmergencia,
        },
        datosGenerales2: {
            resumenHCL: datosGeneralesRINavigation?.resumenHCL,
            diagnosticoAlta: datosGeneralesRINavigation?.diagnosticoAlta,
            diagnosticosRI: datosGeneralesRINavigation?.diagnosticoRI?.map(x => ({
                codigo: x.idDiagnostico,
                codigoItem: x.idItemDiagnostico,
                descripcionItem: x.idItemDiagnosticoNavigation.descripcion ?? x.idItemDiagnostico
            })),
            enfermedadOncologica: datosGeneralesRINavigation?.enfermedadOncologica,
            antecedentesClinicos: datosGeneralesRINavigation?.antecedenteClinicoRI.map(x => x.idComboRIValor),
            otrosAntecedentes: datosGeneralesRINavigation?.otrosAntecedentes,
            comentarioRelevante: datosGeneralesRINavigation?.comentarioRelevante,
            alergias: datosGeneralesRINavigation?.alergiaRI.map(x => x.idAlergia),
            otrasAlergias: datosGeneralesRINavigation?.otrasAlergias,
            medicacionHabitual: datosGeneralesRINavigation?.medicacionHabitual,
            estableHemodinamicamente: datosGeneralesRINavigation?.estableHemodinamicamente,
            estableEnfermedad: datosGeneralesRINavigation?.estableEnfermedad,
            nivelConciencia: datosGeneralesRINavigation?.nivelConciencia,
            escaras: datosGeneralesRINavigation?.escaras,
            ostomias: datosGeneralesRINavigation?.ostomias,
            otrosRelevantes: datosGeneralesRINavigation?.otrosRelevantes,
        },
        datosGenerales3: {
            pesoActual: datosGeneralesRINavigation?.pesoActual,
            talla: datosGeneralesRINavigation?.talla,
            idComboRIValorNivelActividad: datosGeneralesRINavigation?.idComboRIValorNivelActividad,
            idComboRIValorAduPerdidaPeso: datosGeneralesRINavigation?.idComboRIValorAduPerdidaPeso,
            aduPesoHabitual: datosGeneralesRINavigation?.aduPesoHabitual,
            idComboRIValorAduEvaluado: datosGeneralesRINavigation?.idComboRIValorAduEvaluado,
            aduIMC: datosGeneralesRINavigation?.aduIMC,
            aduPerdidaPeso: datosGeneralesRINavigation?.aduPerdidaPeso,
            idComboRIValorAduGradoDesnutricion: datosGeneralesRINavigation?.idComboRIValorAduGradoDesnutricion,
            idComboRIValorAduDiagnosticoNutricional: datosGeneralesRINavigation?.idComboRIValorAduDiagnosticoNutricional,
            idComboRIValorAduMetaNutricional: datosGeneralesRINavigation?.idComboRIValorAduMetaNutricional,
            pedCircunferenciaMBraquial: datosGeneralesRINavigation?.pedCircunferenciaMBraquial,
            pedZScoreTalla: datosGeneralesRINavigation?.pedZScoreTalla,
            pedZScorePeso: datosGeneralesRINavigation?.pedZScorePeso,
            pedZScoreIMC: datosGeneralesRINavigation?.pedZScoreIMC,
            idComboRIValorPedDiagnosticoNutricional: datosGeneralesRINavigation?.idComboRIValorPedDiagnosticoNutricional,
            idComboRIValorPedMetaSoporteNutricional: datosGeneralesRINavigation?.idComboRIValorPedMetaSoporteNutricional,
            requerimientosExtraNutricionalesRI: datosGeneralesRINavigation?.requerimientosExtraNutricionalesRI.map(x => x.idComboRIValor),
            justificacionSoporteRI: datosGeneralesRINavigation?.justificacionSoporteRI.map(x => x.idComboRIValor),
        }
    }
}
